import * as React from 'react';
import { setFeatureFlag, FeatureName } from 'owa-feature-flags';
import { observer } from 'mobx-react-lite';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Label } from 'office-ui-fabric-react/lib/Label';

const styles = require('./FeatureFlagsListItem.scss');
export interface Props {
    name: string;
    isOn: boolean;
    description?: string;
    noFilter: boolean;
}

export default observer(function FeatureFlagsListItem({
    name,
    isOn,
    description,
    noFilter,
}: Props) {
    const showDescription = !!description && !noFilter;
    const onToggle = React.useCallback(value => setFeatureFlag(name as FeatureName, !isOn), [
        name,
        isOn,
    ]);

    return (
        <div>
            <div className={styles.container} title={description}>
                <Toggle
                    checked={isOn}
                    onText={''}
                    offText={''}
                    className={styles.toggle}
                    onChanged={onToggle}
                    title={name}
                />
                <Link href={`https://ninja.outlookweb.io/#FlightDetails|${name}`} target="_blank">
                    {name}
                </Link>
            </div>
            {showDescription && (
                <div>
                    <Label disabled={true}> {description}</Label>
                </div>
            )}
        </div>
    );
});
